import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as epics from '../../../../epics'
import * as requirement from '../requirement'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: requirement.RESOURCE.payload.dimension.partialId,
      partialId: requirement.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'The Jira epic this task or story belongs to, if any.',
    isOptional: true,
    name: 'Epic',
    partialId: PartialId.Standard.create('epic'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(epics.RESOURCE.payload),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
